module.exports = __webpack_public_path__ + "img/horizontal_7_1_5012.69380187.png";